export const PLATFORM_LIST = [
  {
    id: 'ACEWINFISH',
    name: 'ACEWIN FISH',
    abbr: 'AWF',
    gameType: 'FH',
    actions: ['betNSettle', 'cancelBettleNSettle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'ACEWINSLOT',
    name: 'ACEWIN SLOT',
    abbr: 'AWS',
    gameType: 'SLOT',
    actions: ['betNSettle', 'cancelBettleNSettle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  // {
  //   id: 'AELIVECOMM',
  //   name: 'AELIVECOMM',
  //   abbr: 'AE7',
  //   gameType: 'LIVE',
  //   actions: ['bet', 'cancelBet', 'settle', 'resettle', 'voidSettle', 'tip', 'cancelTip'],
  //   formFields: ['callbackUrl', 'key', 'userId1', 'userId2', 'userId3', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
  //   balanceMultiplier: 50,
  // },
  // {
  //   id: 'AELOTTO',
  //   name: 'AE LOTTO',
  //   abbr: 'AEL',
  //   gameType: 'LOTTO',
  //   actions: ['bet', 'cancelBet', 'settle', 'unsettle', 'voidBet'],
  //   formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
  //   balanceMultiplier: 10,
  // },
  {
    id: 'AVIATOR',
    name: 'AVIATOR',
    abbr: 'AVT',
    gameType: 'EGAME',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  // {
  //   id: 'AWSEGAME',
  //   name: 'AWS EGAME',
  //   abbr: 'AEE',
  //   gameType: 'EGAME',
  //   actions: ['betNSettle', 'cancelBettleNSettle'],
  //   formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
  //   balanceMultiplier: 10,
  // },
  // {
  //   id: 'AWSSLOT',
  //   name: 'AWS SLOT',
  //   abbr: 'AES',
  //   gameType: 'SLOT',
  //   actions: ['betNSettle', 'cancelBettleNSettle'],
  //   formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
  //   balanceMultiplier: 10,
  // },
  // {
  //   id: 'AWSTABLE',
  //   name: 'AWS TABLE',
  //   abbr: 'AET',
  //   gameType: 'TABLE',
  //   actions: ['betNSettle', 'cancelBettleNSettle'],
  //   formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
  //   balanceMultiplier: 10,
  // },
  {
    id: 'BG',
    name: 'BG',
    abbr: 'BG',
    gameType: 'LIVE',
    supportMultiBetsInARound: true,
    actions: ['bet', 'cancelBet', 'settle', 'resettle', 'voidBet', 'voidSettle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 50,
  },
  {
    id: 'BTG',
    name: 'BTG',
    abbr: 'BTG',
    gameType: 'SLOT',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'CGEGAME',
    name: 'CG EGAME',
    abbr: 'CGE',
    gameType: 'EGAME',
    actions: ['bet', 'cancelBet', 'settle', 'voidSettle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'CGSLOT',
    name: 'CG SLOT',
    abbr: 'CGS',
    gameType: 'SLOT',
    actions: ['bet', 'cancelBet', 'settle', 'voidSettle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'COMBO',
    name: 'COMBO',
    abbr: 'CBS',
    gameType: 'SLOT',
    actions: ['betNSettle', 'cancelBettleNSettle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'COOLGAME',
    name: 'COOLGAME',
    abbr: 'CGT',
    gameType: 'TABLE',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'CRASH88',
    name: 'CRASH88',
    abbr: 'C88',
    gameType: 'EGAME',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'CREEDROOMZ',
    name: 'CREEDROOMZ',
    abbr: 'CRZ',
    gameType: 'LIVE',
    supportMultiBetsInARound: false,
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'CQ9EGAME',
    name: 'CQ9 EGAME',
    abbr: 'CQ9E',
    gameType: 'EGAME',
    actions: ['bet', 'cancelBet', 'settle', 'resettle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'CQ9FISH',
    name: 'CQ9 FISH',
    abbr: 'CQ9F',
    gameType: 'FH',
    actions: ['bet', 'cancelBet', 'settle', 'resettle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'CQ9SLOT',
    name: 'CQ9 SLOT',
    abbr: 'CQ9S',
    gameType: 'SLOT',
    actions: ['bet', 'cancelBet', 'settle', 'resettle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'CQ9TABLE',
    name: 'CQ9 TABLE',
    abbr: 'CQ9T',
    gameType: 'TABLE',
    actions: ['bet', 'cancelBet', 'settle', 'resettle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'DRAGOONSOFT',
    name: 'DRAGOONSOFT',
    abbr: 'DGS',
    gameType: 'SLOT',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'E1SPORT',
    name: 'E1SPORT',
    abbr: 'ESP',
    gameType: 'SPORTS',
    actions: ['bet', 'cancelBet', 'adjustBet', 'settle', 'resettle', 'voidBet', 'voidSettle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 25,
  },
  {
    id: 'EVOLUTION',
    name: 'EVOLUTION',
    abbr: 'EVO',
    gameType: 'LIVE',
    supportMultiBetsInARound: false,
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'FASTSPINSLOT',
    name: 'FASTSPIN SLOT',
    abbr: 'FSS',
    gameType: 'SLOT',
    actions: ['bet', 'cancelBet', 'settle', 'give'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'FASTSPINFISH',
    name: 'FASTSPIN FISH',
    abbr: 'FSF',
    gameType: 'FH',
    actions: ['betNSettle', 'cancelBettleNSettle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'FCEGAME',
    name: 'FC EGAME',
    abbr: 'FCE',
    gameType: 'EGAME',
    actions: ['bet', 'cancelBet', 'settle', 'betNSettle', 'cancelBettleNSettle', 'give'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'FCFISH',
    name: 'FC FISH',
    abbr: 'FCF',
    gameType: 'FH',
    actions: ['betNSettle', 'cancelBettleNSettle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'FCSLOT',
    name: 'FC SLOT',
    abbr: 'FCS',
    gameType: 'SLOT',
    actions: ['betNSettle', 'cancelBettleNSettle', 'give'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'FIVEG',
    name: 'FIVEG',
    abbr: '5GS',
    gameType: 'SLOT',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'GOGOLI',
    name: 'GOGOLI',
    abbr: 'GGL',
    gameType: 'LIVE',
    actions: ['bet', 'cancelBet', 'settle', 'voidBet'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'GTFFISH',
    name: 'GTF FISH',
    abbr: 'GTFF',
    gameType: 'FH',
    actions: ['betNSettle', 'cancelBettleNSettle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'GTFSLOT',
    name: 'GTF SLOT',
    abbr: 'GTFS',
    gameType: 'SLOT',
    actions: ['betNSettle', 'cancelBettleNSettle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'HABANEROEGAME',
    name: 'HABANERO EGAME',
    abbr: 'HNE',
    gameType: 'EGAME',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'HABANEROSLOT',
    name: 'HABANERO SLOT',
    abbr: 'HNS',
    gameType: 'SLOT',
    actions: ['betNSettle', 'cancelBettleNSettle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'HACKSAWSLOT',
    name: 'HACKSAW SLOT',
    abbr: 'HSS',
    gameType: 'SLOT',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'HACKSAWEGAME',
    name: 'HACKSAW EGAME',
    abbr: 'HSE',
    gameType: 'EGAME',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'HORSEBOOK',
    name: 'HORSEBOOK',
    abbr: 'HRB',
    gameType: 'LIVE',
    supportMultiBetsInARound: true,
    actions: ['bet', 'cancelBet', 'adjustBet', 'settle', 'unsettle', 'voidBet', 'unvoidBet', 'voidSettle'],
    formFields: ['callbackUrl', 'key', 'userIdPrefix', 'userId1', 'userId2', 'userId3', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 45,
  },
  {
    id: 'HOTROAD',
    name: 'HOTROAD',
    abbr: 'HR',
    gameType: 'LIVE',
    supportMultiBetsInARound: true,
    actions: ['bet', 'cancelBet', 'settle', 'voidBet'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'IDNSLOT',
    name: 'IDN SLOT',
    abbr: 'IDS',
    gameType: 'SLOT',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  // {
  //   id: 'ILOVEU',
  //   name: 'ILOVEU',
  //   abbr: 'ILU',
  //   gameType: 'SLOT',
  //   actions: ['betNSettle', 'cancelBettleNSettle'],
  //   formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
  //   balanceMultiplier: 10,
  // },
  {
    id: 'INSPORTS',
    name: 'INSPORTS',
    abbr: 'ISP',
    gameType: 'SPORTS',
    actions: ['bet', 'cancelBet', 'adjustBet', 'voidtBet', 'settle', 'resettle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'JDBEGAME',
    name: 'JDB EGAME',
    abbr: 'JDBE',
    gameType: 'EGAME',
    actions: ['bet', 'cancelBet', 'settle', 'betNSettle', 'cancelBettleNSettle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'JDBFISH',
    name: 'JDB FISH',
    abbr: 'JDBF',
    gameType: 'FH',
    actions: ['betNSettle', 'cancelBettleNSettle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'JDBSLOT',
    name: 'JDB SLOT',
    abbr: 'JDBS',
    gameType: 'SLOT',
    actions: ['betNSettle', 'cancelBettleNSettle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'JDBTABLE',
    name: 'JDB TABLE',
    abbr: 'JDBT',
    gameType: 'TABLE',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'JILIFISH',
    name: 'JILI FISH',
    abbr: 'JLF',
    gameType: 'FH',
    actions: ['betNSettle', 'cancelBettleNSettle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'JILISLOT',
    name: 'JILI SLOT',
    abbr: 'JLS',
    gameType: 'SLOT',
    actions: ['betNSettle', 'cancelBettleNSettle', 'give'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'JILITABLE',
    name: 'JILI TABLE',
    abbr: 'JLT',
    gameType: 'TABLE',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  // {
  //   id: 'JJEGAME',
  //   name: 'JJ (2J) EGAME',
  //   abbr: 'JJE',
  //   gameType: 'EGAME',
  //   actions: ['bet', 'cancelBet', 'settle'],
  //   formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
  //   balanceMultiplier: 10,
  // },
  // {
  //   id: 'JJSLOT',
  //   name: 'JJ (2J) SLOT',
  //   abbr: 'JJS',
  //   gameType: 'SLOT',
  //   actions: ['bet', 'cancelBet', 'settle'],
  //   formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
  //   balanceMultiplier: 10,
  // },
  {
    id: 'JOKER',
    name: 'JOKER',
    abbr: 'JK',
    gameType: 'SLOT',
    actions: ['bet', 'cancelBet', 'settle', 'betNSettle', 'cancelBetNSettle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'KINGMAKERSLOT',
    name: 'KINGMAKER (KINGMIDAS) SLOT',
    abbr: 'KMS',
    gameType: 'SLOT',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userIdPrefix', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'KINGMAKERTABLE',
    name: 'KINGMAKER (KINGMIDAS) TABLE',
    abbr: 'KMT',
    gameType: 'TABLE',
    actions: ['bet', 'cancelBet', 'settle', 'give'],
    formFields: ['callbackUrl', 'key', 'userIdPrefix', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'KINGMAKERMINI',
    name: 'KINGMAKERMINI',
    abbr: 'KMMN',
    gameType: 'TABLE',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userIdPrefix', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'LADYLUCK',
    name: 'LADYLUCK',
    abbr: 'LL',
    gameType: 'SLOT',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'LETSGO',
    name: 'LETSGO',
    abbr: 'LG',
    gameType: 'SLOT',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'LUCKY365EGAME',
    name: 'LUCKY365 EGAME',
    abbr: 'LKE',
    gameType: 'EGAME',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'LUCKY365SLOT',
    name: 'LUCKY365 SLOT',
    abbr: 'LKS',
    gameType: 'SLOT',
    actions: ['betNSettle', 'cancelBettleNSettle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'LUCKYPOKER',
    name: 'LUCKYPOKER',
    abbr: 'LP',
    gameType: 'TABLE',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userIdPrefix', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'LUDO',
    name: 'LUDO',
    abbr: 'LD',
    gameType: 'TABLE',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userIdPrefix', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'MAC88',
    name: 'MAC88',
    abbr: 'MAC',
    gameType: 'LIVE',
    supportMultiBetsInARound: true,
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'MGEGAME',
    name: 'MG EGAME',
    abbr: 'MGE',
    gameType: 'EGAME',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'MGLIVE',
    name: 'MG LIVE',
    abbr: 'MGL',
    gameType: 'LIVE',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'MGSLOT',
    name: 'MG SLOT',
    abbr: 'MGS',
    gameType: 'SLOT',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'MICROSLOTEGAME',
    name: 'MICROSLOT EGAME',
    abbr: 'MCS',
    gameType: 'SLOT',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'MICROSLOTSLOT',
    name: 'MICROSLOT SLOT',
    abbr: 'MCS',
    gameType: 'SLOT',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'MIMIEGAME',
    name: 'MIMI EGAME',
    abbr: 'MME',
    gameType: 'EGAME',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'MIMISLOT',
    name: 'MIMI SLOT',
    abbr: 'MMS',
    gameType: 'SLOT',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'MT',
    name: 'MT',
    abbr: 'MT',
    gameType: 'LIVE',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'NEXTSPIN',
    name: 'NEXTSPIN',
    abbr: 'NEX',
    gameType: 'SLOT',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'NETENTSLOT',
    name: 'NETENT SLOT',
    abbr: 'NES',
    gameType: 'SLOT',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'NETENTTABLE',
    name: 'NETENT TABLE',
    abbr: 'NET',
    gameType: 'TABLE',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'NLC',
    name: 'NLC',
    abbr: 'NLC',
    gameType: 'SLOT',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'OCTOPLAY',
    name: 'OCTOPLAY',
    abbr: 'OCT',
    gameType: 'SLOT',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'ODIN',
    name: 'ODIN',
    abbr: 'ODN',
    gameType: 'SLOT',
    actions: ['betNSettle', 'cancelBettleNSettle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'PGSLOT',
    name: 'PG SLOT',
    abbr: 'PGS',
    gameType: 'SLOT',
    actions: ['betNSettle', 'cancelBettleNSettle', 'give'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  // {
  //   id: 'PGSLOTOLD',
  //   name: 'PG SLOT (bet/settle)',
  //   abbr: 'PGSO',
  //   gameType: 'SLOT',
  //   actions: ['bet', 'cancelBet', 'settle'],
  //   formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
  //   balanceMultiplier: 3,
  // },
  {
    id: 'PENGUINKING',
    name: 'PENGUINKING',
    abbr: 'PGK',
    gameType: 'SLOT',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'PGTABLE',
    name: 'PG TABLE',
    abbr: 'PGT',
    gameType: 'TABLE',
    actions: ['betNSettle', 'cancelBettleNSettle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'PINNACLE',
    name: 'PINNACLE',
    abbr: 'PNC',
    gameType: 'SPORTS',
    actions: ['bet', 'cancelBet', 'adjustBet', 'settle', 'resettle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  // {
  //   id: 'PINOYPERYAHAN',
  //   name: 'PINOYPERYAHAN',
  //   abbr: 'PPH',
  //   gameType: 'LIVE',
  //   actions: ['bet', 'cancelBet', 'adjustBet', 'settle'],
  //   formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
  //   balanceMultiplier: 10,
  // },
  {
    id: 'PLAY8FISH',
    name: 'PLAY8 FISH',
    abbr: 'P8F',
    gameType: 'FH',
    actions: ['betNSettle', 'cancelBettleNSettle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'PLAY8SLOT',
    name: 'PLAY8 SLOT',
    abbr: 'P8S',
    gameType: 'SLOT',
    actions: ['betNSettle', 'cancelBettleNSettle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'PLAYNGOBINGO',
    name: 'PLAYNGO BINGO',
    abbr: 'PNGB',
    gameType: 'SLOT',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'PLAYNGOEGAME',
    name: 'PLAYNGO EGAME',
    abbr: 'PNGE',
    gameType: 'SLOT',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'PLAYNGOSLOT',
    name: 'PLAYNGO SLOT',
    abbr: 'PNGS',
    gameType: 'SLOT',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'PLAYNGOTABLE',
    name: 'PLAYNGO TABLE',
    abbr: 'PNGT',
    gameType: 'TABLE',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'PLAYSTAR',
    name: 'PLAYSTAR',
    abbr: 'PS',
    gameType: 'SLOT',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'PLAYTECHEGAME',
    name: 'PLAYTECH EGAME',
    abbr: 'PTE',
    gameType: 'EGAME',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'PLAYTECHLIVE',
    name: 'PLAYTECH LIVE',
    abbr: 'PTL',
    gameType: 'LIVE',
    supportMultiBetsInARound: true,
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'PLAYTECHSLOT',
    name: 'PLAYTECH SLOT',
    abbr: 'PTS',
    gameType: 'SLOT',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'PLAYTECHTABLE',
    name: 'PLAYTECH TABLE',
    abbr: 'PTT',
    gameType: 'TABLE',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'PPEGAME',
    name: 'PP EGAME',
    abbr: 'PPE',
    gameType: 'EGAME',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'PPLIVE',
    name: 'PP LIVE',
    abbr: 'PPL',
    gameType: 'LIVE',
    supportMultiBetsInARound: true,
    actions: ['bet', 'cancelBet', 'settle', 'resettle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'PPSLOT',
    name: 'PP SLOT',
    abbr: 'PPS',
    gameType: 'SLOT',
    actions: ['bet', 'cancelBet', 'settle', 'betNSettle', 'give'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'PPTABLE',
    name: 'PP TABLE',
    abbr: 'PPT',
    gameType: 'TABLE',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'PTLIVE',
    name: 'PT LIVE',
    abbr: 'PTL',
    gameType: 'LIVE',
    supportMultiBetsInARound: true,
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'PTSLOT',
    name: 'PT SLOT',
    abbr: 'PTS',
    gameType: 'SLOT',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'RELAXEGAME',
    name: 'RELAX EGAME',
    abbr: 'RLE',
    gameType: 'EGAME',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'RELAXSLOT',
    name: 'RELAX SLOT',
    abbr: 'RLS',
    gameType: 'SLOT',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'RELAXTABLE',
    name: 'RELAX TABLE',
    abbr: 'RLT',
    gameType: 'TABLE',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'RICH88EGAME',
    name: 'RICH88 EGAME',
    abbr: 'R8E',
    gameType: 'EGAME',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'RICH88SLOT',
    name: 'RICH88 SLOT',
    abbr: 'R8S',
    gameType: 'SLOT',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'RICH88TABLE',
    name: 'RICH88 TABLE',
    abbr: 'R8T',
    gameType: 'TABLE',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'ROYALGAMING',
    name: 'ROYALGAMING',
    abbr: 'RG',
    gameType: 'LIVE',
    supportMultiBetsInARound: true,
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'RTSLOT',
    name: 'RT SLOT',
    abbr: 'RTS',
    gameType: 'SLOT',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'RTTABLE',
    name: 'RT TABLE',
    abbr: 'RTT',
    gameType: 'TABLE',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'SABA',
    name: 'SABA',
    abbr: 'SB',
    gameType: 'VIRTUAL',
    actions: ['bet', 'cancelBet', 'adjustBet', 'settle', 'resettle', 'unsettle', 'voidBet', 'voidSettle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  // {
  //   id: 'SABAOLD',
  //   name: 'SABA',
  //   abbr: 'SBO',
  //   gameType: 'VIRTUAL',
  //   actions: ['bet', 'cancelBet', 'settle', 'unsettle', 'voidBet', 'voidSettle'],
  //   formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
  //   balanceMultiplier: 10,
  // },
  {
    id: 'SEXYBCRT',
    name: 'SEXYBCRT (SEXY CASINO)',
    abbr: 'SXB',
    gameType: 'LIVE',
    supportMultiBetsInARound: true,
    actions: ['bet', 'cancelBet', 'settle', 'resettle', 'voidBet', 'voidSettle', 'tip', 'cancelTip'],
    formFields: ['callbackUrl', 'key', 'userId1', 'userId2', 'userId3', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 50,
  },
  {
    id: 'SEXYBCRT_SUMMARY',
    name: 'SEXYBCRT (SUMMARY)',
    abbr: 'SXS',
    gameType: 'LIVE',
    actions: ['bet', 'cancelBet', 'settle', 'voidBet', 'tip', 'cancelTip'],
    formFields: ['callbackUrl', 'key', 'userIdPrefix', 'userId1', 'userId2', 'userId3', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 50,
  },
  // {
  //   id: 'SEXYBCRT_ONEDAY',
  //   name: 'SEXYBCRT - OneDay',
  //   abbr: 'OD',
  //   gameType: 'LIVE',
  //   actions: ['adjustAmt', 'cancelAdjustAmt'],
  //   formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
  //   balanceMultiplier: 3,
  // },
  {
    id: 'SKYCASINO',
    name: 'SKYCASINO',
    abbr: 'SKC',
    gameType: 'LIVE',
    supportMultiBetsInARound: true,
    actions: ['bet', 'cancelBet', 'settle', 'resettle', 'voidBet', 'voidSettle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'userId2', 'userId3', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 50,
  },
  {
    id: 'SMARTSOFT',
    name: 'SMARTSOFT',
    abbr: 'SSE',
    gameType: 'EGAME',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'SPADEEGAME',
    name: 'SPADE EGAME',
    abbr: 'SGE',
    gameType: 'EGAME',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'SPADEFISH',
    name: 'SPADE FISH',
    abbr: 'SGF',
    gameType: 'FH',
    actions: ['betNSettle', 'cancelBettleNSettle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'SPADESLOT',
    name: 'SPADE SLOT',
    abbr: 'SGS',
    gameType: 'SLOT',
    actions: ['bet', 'cancelBet', 'settle', 'freeSpin', 'give'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'SPRIBE',
    name: 'SPRIBE',
    abbr: 'SPR',
    gameType: 'EGAME',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'SV388',
    name: 'SV388',
    abbr: 'CF',
    gameType: 'LIVE',
    supportMultiBetsInARound: true,
    actions: ['bet', 'cancelBet', 'adjustBet', 'refund', 'settle', 'unsettle', 'voidBet', 'unvoidBet', 'voidSettle', 'unvoidSettle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'userId2', 'userId3', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 25,
  },
  {
    id: 'TADAEGAME',
    name: 'TADA EGAME',
    abbr: 'TDE',
    gameType: 'EGAME',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'TADAFISH',
    name: 'TADA FISH',
    abbr: 'TDF',
    gameType: 'FH',
    actions: ['betNSettle', 'cancelBettleNSettle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'TADASLOT',
    name: 'TADA SLOT',
    abbr: 'TDS',
    gameType: 'SLOT',
    actions: ['betNSettle', 'cancelBettleNSettle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'TADATABLE',
    name: 'TADA TABLE',
    abbr: 'TDT',
    gameType: 'TABLE',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'THREEOAKS',
    name: 'THREEOAKS',
    abbr: 'TOS',
    gameType: 'SLOT',
    actions: ['betNSettle', 'cancelBettleNSettle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  // {
  //   id: 'VENUS',
  //   name: 'VENUS',
  //   abbr: 'VN',
  //   gameType: 'LIVE',
  //   actions: ['bet', 'cancelBet', 'settle', 'resettle', 'voidBet', 'voidSettle'],
  //   formFields: ['callbackUrl', 'key', 'userId1', 'userId2', 'userId3', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
  //   balanceMultiplier: 50,
  // },
  {
    id: 'VIACASINO',
    name: 'VIACASINO',
    abbr: 'VC',
    gameType: 'LIVE',
    supportMultiBetsInARound: true,
    actions: ['bet', 'cancelBet', 'settle', 'resettle', 'voidBet', 'voidSettle'],
    formFields: ['callbackUrl', 'key', 'userIdPrefix', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 50,
  },
  {
    id: 'VRLOTTO',
    name: 'VRLOTTO',
    abbr: 'VRL',
    gameType: 'LOTTO',
    actions: ['bet', 'cancelBet', 'settle', 'resettle', 'voidBet'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'WINFINITY',
    name: 'WINFINITY',
    abbr: 'WFT',
    gameType: 'LIVE',
    supportMultiBetsInARound: false,
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'YESBINGOBINGO',
    name: 'YESBINGO (YELLOWBAT) BINGO',
    abbr: 'YBB',
    gameType: 'BINGO',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'YESBINGOEGAME',
    name: 'YESBINGO (YELLOWBAT) EGAME',
    abbr: 'YBS',
    gameType: 'EGAME',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'YESBINGOFISH',
    name: 'YESBINGO (YELLOWBAT) FISH',
    abbr: 'YBF',
    gameType: 'FH',
    actions: ['betNSettle', 'cancelBettleNSettle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'YESBINGOSLOT',
    name: 'YESBINGO (YELLOWBAT) SLOT',
    abbr: 'YBS',
    gameType: 'SLOT',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
  {
    id: 'YGGDRASILSLOT',
    name: 'YGGDRASIL SLOT',
    abbr: 'YGS',
    gameType: 'SLOT',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'YGGDRASILTABLE',
    name: 'YGGDRASIL TABLE',
    abbr: 'YGT',
    gameType: 'TABLE',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'YLEGAME',
    name: 'YL EGAME',
    abbr: 'YLE',
    gameType: 'EGAME',
    actions: ['bet', 'cancelBet', 'settle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'YLFISH',
    name: 'YL FISH',
    abbr: 'YLF',
    gameType: 'FH',
    actions: ['betNSettle', 'cancelBettleNSettle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 10,
  },
  {
    id: 'PGSLOTMIXED',
    name: 'INTERNAL USE',
    abbr: 'PGSM',
    gameType: 'SLOT',
    actions: ['bet', 'settle', 'betNSettle'],
    formFields: ['callbackUrl', 'key', 'userId1', 'currency', 'betAmount', 'balanceDecimalPlaces', 'supportPremium', 'skippedTestScenarios'],
    balanceMultiplier: 3,
  },
]

export const ACTION_LIST = [
  {
    id: 'bet',
    name: 'Bet',
  },
  {
    id: 'cancelBet',
    name: 'CancelBet',
  },
  {
    id: 'settle',
    name: 'Settle',
  },
  {
    id: 'adjustBet',
    name: 'AdjustBet',
  },
  {
    id: 'unsettle',
    name: 'Unsettle',
  },
  {
    id: 'resettle',
    name: 'Resettle',
  },
  {
    id: 'voidBet',
    name: 'VoidBet',
  },
  {
    id: 'unvoidBet',
    name: 'UnvoidBet',
  },
  {
    id: 'voidSettle',
    name: 'VoidSettle',
  },
  {
    id: 'unvoidSettle',
    name: 'UnvoidSettle',
  },
  {
    id: 'betNSettle',
    name: 'BetNSettle',
  },
  {
    id: 'cancelBettleNSettle',
    name: 'CancelBettleNSettle',
  },
  {
    id: 'adjustAmt',
    name: 'AdjustAmt',
  },
  {
    id: 'cancelAdjustAmt',
    name: 'CancelAdjustAmt',
  },
  {
    id: 'tip',
    name: 'Tip',
  },
  {
    id: 'cancelTip',
    name: 'CancelTip',
  },
  {
    id: 'give',
    name: 'Give',
  },
  {
    id: 'refund',
    name: 'Refund',
  },
  {
    id: 'freeSpin',
    name: 'FreeSpin',
  },
]

export const PARAMETER_FORM_FIELDS = [
  {
    id: 'callbackUrl',
    defaultValue: undefined,
    element: 'input',
    inputType: 'text',
    rules: [
      {
        required: true,
        message: 'rule-correct-url-format',
      },
      {
        // type: 'url',
        // eslint-disable-next-line no-useless-escape
        pattern: /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}(\.[a-zA-Z0-9()]){0,6}\b([-a-zA-Z0-9()!@:%_\+.~#?&\/\/=]*)$/,
        message: 'rule-correct-url-format',
        trigger: 'blur',
      },
    ],
  },
  {
    id: 'key',
    defaultValue: undefined,
    element: 'input',
    inputType: 'text',
    rules: [
      {
        required: true,
        message: 'rule-enter-key',
      },
    ],
  },
  {
    id: 'userIdPrefix',
    defaultValue: undefined,
    element: 'input',
    inputType: 'text',
    maxlength: 3,
    rules: [
      {
        required: true,
        message: 'rule-enter-user-id-prefix',
      },
      {
        pattern: /^[A-Za-z0-9]+$/,
        message: 'rule-correct-user-id-prefix-format',
        trigger: 'blur',
      },
    ],
  },
  {
    id: 'userId1',
    defaultValue: undefined,
    element: 'input',
    inputType: 'text',
    rules: [
      {
        required: true,
        message: 'rule-enter-user-id-1',
      },
      {
        pattern: /^[A-Za-z0-9]+$/,
        message: 'rule-correct-user-id-format',
        trigger: 'blur',
      },
    ],
    toolTip: 'tip-user-id',
    toolTipTrigger: 'hover',
  },
  {
    id: 'userId2',
    defaultValue: undefined,
    element: 'input',
    inputType: 'text',
    rules: [
      {
        required: true,
        message: 'rule-enter-user-id-2',
      },
      {
        pattern: /^[A-Za-z0-9]+$/,
        message: 'rule-correct-user-id-format',
        trigger: 'blur',
      },
    ],
    toolTip: 'tip-user-id-same-currency',
    toolTipTrigger: 'hover',
  },
  {
    id: 'userId3',
    defaultValue: undefined,
    element: 'input',
    inputType: 'text',
    rules: [
      {
        required: true,
        message: 'rule-enter-user-id-3',
      },
      {
        pattern: /^[A-Za-z0-9]+$/,
        message: 'rule-correct-user-id-format',
        trigger: 'blur',
      },
    ],
    toolTip: 'tip-user-id-same-currency',
    toolTipTrigger: 'hover',
  },
  {
    id: 'currency',
    defaultValue: undefined,
    element: 'select',
    options: [],
    rules: [
      {
        required: true,
        message: 'rule-select-currency',
      },
    ],
    toolTipTrigger: 'hover',
    showSearch: true,
  },
  {
    id: 'betAmount',
    defaultValue: undefined,
    element: 'input-number',
    inputType: 'number',
    min: 0.01,
    max: 9999999999999.99,
    step: 0.01,
    rules: [
      {
        required: true,
        message: 'rule-enter-bet-amount',
      },
    ],
    toolTip: 'tip-bet-amount',
    toolTipTrigger: 'focus',
  },
  {
    id: 'balanceDecimalPlaces',
    defaultValue: 3,
    inputType: 'number',
    element: 'select',
    options: [0, 1, 2, 3].map(i => ({ label: i, value: i })),
    rules: [
      {
        required: true,
        message: 'rule-select-balanceDecimalPlaces',
      },
    ],
    toolTip: 'tip-balanceDecimalPlaces',
    toolTipTrigger: 'hover',
  },
  {
    id: 'supportPremium',
    defaultValue: false,
    element: 'switch',
    toolTip: 'tip-supportPremium',
    toolTipTrigger: 'hover',
  },
  {
    id: 'skippedTestScenarios',
    defaultValue: [],
    rules: [],
  },
]

export const DEFAULT_PLATFORM_CLIENT_DATA = {
  // callbackUrl: 'http://localhost:8081/single-wallet-agent/api/callback/AWS03_RP',
  // key: 'tDSKP5QTbDyVxn0Nszs',
  // userId1: 'devautotestthb1',
  callbackUrl: 'http://localhost:8081/single-wallet-agent/api/callback/UAT',
  key: 'rGjZikeTOMVR9g11RMY',
  userIdPrefix: 'ts0',
  // key: 'gDvXVKDDcuMirCnMOF9',
  // userIdPrefix: 'sw0',
  userId1: 'thbtest1',
  userId2: 'thbtest2',
  userId3: 'thbtest3',
  currency: 'THB',
  betAmount: 10,
  balanceDecimalPlaces: 3,
  supportPremium: false,

  // callbackUrl: 'http://www.myawaddyonline999.com/callbackswl/callback.php',
  // key: '>^.K4_3wnkk5&MgQ',
  // userIdPrefix: 'pre',
  // userId1: 'awctestcny',
  // userId2: 'awctestcny2',
  // userId3: 'awctestcny3',
  // currency: 'CNY',
  // betAmount: 10,
  // balanceDecimalPlaces: 2,
  // skippedTestScenarios: [],
}
